<template>
  <div class="container">
    <b-form @submit.prevent="doSubmit()" novalidate>
      <div class="row mb-2">
        <div class="col-md-12">
          <h4 class="h4">
            Actualización de datos 2025
          </h4>
        </div>
      </div>
      <div class="row">

        <!-- Gov Id-->
        <div class="col-md-6">
          <b-form-group class="form-label" label="Número de cédula">
            <b-input-group id="kgroup" class="mb-2 mr-sm-2 mb-sm-0">
              <b-form-input min="0" type="number" v-model="form.govId"
                :state="isValidValue(form.govId) && isValidGovId()" @keyup.enter.native="doSearchEmployee()"
                @change="cleanData()" placeholder="Número de cédula" required>
              </b-form-input>
              <div class="text-center" v-if="loadingEmployee">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Cargando...</span>
                </div>
              </div>
              <b-button class="is-primary" type="button"
                :disabled="!isValidValue(form.govId) || !isValidGovId() || loadingEmployee" role="button"
                @click="doSearchEmployee()" variant="primary">
                Buscar
              </b-button>
            </b-input-group>
          </b-form-group>
        </div>
        <!-- Gov Id-->

        <!-- Image -->
        <div class="col-md-6" v-if="loadedEmployee">
          <b-form-group class="form-label" label="Fotografía">
            <b-form-file browse-text="Buscar imágen" type="file" ref="file-input"
              @change="onFileChange('image_url', 'imageLoader')" placeholder="Por favor elija un archivo">
            </b-form-file>
            <span v-if="!form.image_url" style="color: #d60000">
              * Imágen requerida </span>
          </b-form-group>
          <div class="text-center" v-if="imageLoader">
            <div class="spinner-border" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
        </div>
        <!-- Image -->

      </div>

      <div class="row">
        <!-- Code -->
        <div class="col-md-6 col-sm-12">
          <b-form-group class="form-label" label="Número de gafete">
            <b-form-input v-model="form.code" placeholder="- -" disabled>
            </b-form-input>
          </b-form-group>
        </div>
        <!-- Code -->

        <!-- Name -->
        <div class="col-md-6 col-sm-12">
          <b-form-group class="form-label" label="Nombre completo">
            <b-form-input v-model="form.name" min="0" placeholder="- -" required disabled>
            </b-form-input>
          </b-form-group>
        </div>
        <!-- Name -->

      </div>

      <div id="content" class="mb-5" v-if="loadedEmployee">
        <br />
        <h5 style="text-align: left">Datos personales</h5>
        <hr />

        <div class="row">
          <!-- Phone -->
          <div class="col-md-6 col-sm-12">
            <b-form-group class="form-label" label="Teléfono">
              <b-form-input v-model="form.phone" :state="isValidPhone(form.phone) && isValidValue(form.phone)"
                :maxlength="9" v-mask="'####-####'" placeholder="Teléfono">
              </b-form-input>
              <b-form-invalid-feedback id="phone-feedback-1" v-if="!isValidValue(form.phone)">
                Por favor ingrese su número de teléfono
              </b-form-invalid-feedback>
              <b-form-invalid-feedback id="phone-feedback-2" v-if="!isValidPhone() && isValidValue(form.phone)">
                El teléfono ingresado es inválido
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <!-- Phone -->

          <!-- Phone -->
          <div class="col-md-6 col-sm-12">
            <b-form-group class="form-label" label="Celular">
              <b-form-input v-model="form.cell_phone"
                :state="isValidPhone(form.cell_phone) && isValidValue(form.cell_phone)" :maxlength="9"
                v-mask="'####-####'" placeholder="Celular">
              </b-form-input>
              <b-form-invalid-feedback id="cell_phone-feedback-1" v-if="!isValidValue(form.cell_phone)">
                Por favor ingrese su número de celular
              </b-form-invalid-feedback>
              <b-form-invalid-feedback id="cell_phone-feedback-2"
                v-if="!isValidPhone(form.cell_phone) && isValidValue(form.cell_phone)">
                El celular ingresado es inválido
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <!-- Phone -->

          <!-- Email -->
          <div class="col-md-6 col-sm-12">
            <b-form-group class="form-label" label="Correo electrónico">
              <b-form-input :state="isValidEmail(form.email) && isValidValue(form.email)" v-model="form.email"
                placeholder="Correo electrónico" type="email">
              </b-form-input>
              <b-form-invalid-feedback id="email-feedback-1" v-if="!isValidValue(form.email)">
                Por favor ingrese su correo electrónico
              </b-form-invalid-feedback>
              <b-form-invalid-feedback id="email-feedback-2"
                v-if="!isValidEmail(form.email) && isValidValue(form.email)">
                El correo ingresado es inválido
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <!-- Email -->

          <!-- Email Confirmation -->
          <div class="col-md-6 col-sm-12">
            <b-form-group class="form-label" label="Confirmar correo electrónico">
              <b-form-input :state="isValidEmail(form.email_confirmation) && equalsEmail()"
                v-model="form.email_confirmation" placeholder="Confirmar correo electrónico" type="email">
              </b-form-input>
              <b-form-invalid-feedback id="confirmation-feedback-1" v-if="!isValidValue(form.email_confirmation)">
                Por favor confirme su correo electrónico
              </b-form-invalid-feedback>
              <b-form-invalid-feedback id="confirmation-feedback-2" v-if="!equalsEmail(form.email) &&
                isValidValue(form.email_confirmation)
              ">
                Los correos no coinciden
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <!-- Email Confirmation -->
        </div>


        <br />
        <h5 style="text-align: left">Residencia</h5>
        <hr />

        <div class="row">
          <!-- Province -->
          <div class="col-md-4 col-sm-12">
            <b-form-group class="form-label" label="Provincia">
              <b-form-select id="province" v-model="form.province_id" :state="isValidValue(form.province_id)"
                @change="loadCantons()">
                <b-form-select-option :value="province.id" :key="province.id" v-for="province in provinces">
                  {{ province.name }}
                </b-form-select-option>
              </b-form-select>
              <b-form-invalid-feedback id="province">
                Seleccione la provincia donde reside actualmente
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <!-- Province -->

          <!-- Canton -->
          <div class="col-md-4 col-sm-12">
            <b-form-group class="form-label" label="Cantón">
              <b-input-group id="cgroup" class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-select id="canton" v-model="form.canton_id" :state="isValidValue(form.canton_id)"
                  @change="loadDistricts()" :disabled="cantons.length == 0">
                  <b-form-select-option :value="canton.id" :key="canton.id" v-for="canton in cantons">
                    {{ canton.name }}
                  </b-form-select-option>
                </b-form-select>
                <b-form-invalid-feedback id="canton-feedback" v-if="cantons.length > 0">
                  Seleccione el cantón donde vive
                </b-form-invalid-feedback>
                <div class="text-center" v-if="loadingCantons">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Cargando...</span>
                  </div>
                </div>
              </b-input-group>
            </b-form-group>
          </div>
          <!-- Canton -->

          <!-- District -->
          <div class="col-md-4 col-sm-12">
            <b-form-group class="form-label" label="Distrito">
              <b-input-group id="dgroup" class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-select id="district" v-model="form.district_id" :state="isValidValue(form.district_id)"
                  :disabled="cantons.length == 0" @change="loadAproxLocation()">
                  <b-form-select-option :value="district.id" :key="district.id" v-for="district in districts">
                    {{ district.name }}
                  </b-form-select-option>
                </b-form-select>
                <b-form-invalid-feedback id="district-feedback" v-if="districts.length > 0">
                  Seleccione el cantón donde vive
                </b-form-invalid-feedback>
                <div class="text-center" v-if="loadingDistricts">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Cargando...</span>
                  </div>
                </div>
              </b-input-group>
            </b-form-group>
          </div>
          <!-- District -->

          <!-- Detail -->
          <div class="col-md-12 col-sm-12">
            <b-form-group class="form-label" label="Detalle dirección">
              <b-form-textarea v-model="form.address_detail" :state="isValidValue(form.address_detail)" min="0" required
                placeholder="Detalle dirección">
              </b-form-textarea>
              <b-form-invalid-feedback id="address-feedback" v-if="!isValidValue(form.address_detail)">
                Por favor agregue la dirección exacta de su vivienda
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <!-- Detail -->

          <!-- Location -->
          <div class="col-md-12 col-sm-12">
            <p>Busque la ubicación de su vivienda en el mapa</p>
          </div>

          <!-- Location -->
          <div class="col-md-12 col-sm-12">
            <div class="column no-padding">
              <GmapMap v-if="loadedLocation" :center="center" @click="mark" :zoom="13" ref="mapRef" :options="{
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUI: false,
              }" style="width: 100%; height: 400px">
                <GmapMarker :position="form.marker" :clickable="true" :draggable="true" />
              </GmapMap>
            </div>
          </div>
          <!-- Location -->
        </div>


        <br />
        <h5 style="text-align: left">Contacto de Emergencia</h5>
        <hr />

        <!-- Info -->
        <div class="row">
          <!-- Name -->
          <div class="col-md-12">
            <b-form-group class="form-label sub-title-2" label="Nombre completo">
              <b-form-input v-model="form.emergency_contact.name" required
                :state="isValidValue(form.emergency_contact.name)">
              </b-form-input>
            </b-form-group>
          </div>
          <!-- Name -->

          <!-- Phone -->
          <div class="col-md-6 col-sm-12">
            <b-form-group class="form-label sub-title-2" label="Telefono domicilio">
              <b-form-input v-model="form.emergency_contact.phone" required :maxlength="9" v-mask="'####-####'"
                :state="isValidPhone(form.emergency_contact.phone) && isValidValue(form.emergency_contact.phone)">
              </b-form-input>
              <b-form-invalid-feedback
                v-if="form.emergency_contact.phone != '' && !isValidPhone(form.emergency_contact.phone)">
                El teléfono ingresado es inválido
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <!-- Phone -->

          <!-- CellPhone -->
          <div class="col-md-6 col-sm-12">
            <b-form-group class="form-label sub-title-2" label="Teléfono celular">
              <b-form-input v-model="form.emergency_contact.cell_phone" :maxlength="9" v-mask="'####-####'" required
                :state="isValidPhone(form.emergency_contact.cell_phone) && isValidValue(form.emergency_contact.cell_phone)">
              </b-form-input>
              <b-form-invalid-feedback
                v-if="form.emergency_contact.cell_phone != '' && !isValidPhone(form.emergency_contact.cell_phone)">
                El celular ingresado es inválido
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <!-- CellPhone -->

          <!-- Detail -->
          <div class="col-md-12">
            <b-form-group class="form-label sub-title-2" label="Dirección exacta">
              <b-form-input v-model="form.emergency_contact.detail" required
                :state="isValidValue(form.emergency_contact.detail)">
              </b-form-input>
            </b-form-group>
          </div>
          <!-- Detail -->

          <br />
        </div>
        <!-- Info -->

      </div>

      <br />
      <h5 style="text-align: left">Autorización para el tratamiento de datos personales</h5>
      <hr />

      <div class="row">
        <div class="col-md-12">
          <div class="disclaimer-box">
            <p class="disclaimer-text">
              Los datos aquí suministrados serán utilizados únicamente para fines de actualización de información de
              contacto de colaboradores y para atención en caso de emergencias. En el caso de contactos de emergencia,
              el colaborador declara haber informado a la persona indicada sobre la entrega de sus datos a Corporación
              K-9 y contar con su consentimiento para tal fin.
            </p>
            <p class="disclaimer-text">
              Corporación K-9 garantiza la confidencialidad y seguridad de esta información, conforme a la Ley N.º 8968
              de Protección de la Persona frente al Tratamiento de sus Datos Personales.
            </p>
          </div>

          <b-form-group class="mt-3">
            <b-form-checkbox v-model="form.termsAccepted" :state="form.termsAccepted" required>
              <strong>Acepto los términos y condiciones establecidos anteriormente</strong>
            </b-form-checkbox>
            <b-form-invalid-feedback v-if="!form.termsAccepted">
              Debe aceptar los términos y condiciones para continuar
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
      </div>

      <br />
      <b-button class="is-primary" type="submit" variant="primary" :disabled="loading">
        Enviar información
      </b-button>

      <div class="text-center" v-if="loading">
        <div class="spinner-border" role="status">
          <span class="sr-only">Enviando datos...</span>
        </div>
      </div>
      <br />
    </b-form>

    <b-modal ref="alert-modal" :width="640" scroll="keep" @ok="resetForm()" @cancel="resetForm()">
      <div class="container">
        <div class="content">
          <h1 class="is-5 spaced">
            {{ alert.title }}
          </h1>
          <div v-if="alert.detail.includes('\n')" class="alert-detail-multiline">
            <div v-for="(line, index) in alert.detail.split('\n')" :key="index" class="alert-line">
              {{ line }}
            </div>
          </div>
          <p v-else class="detail">
            {{ alert.detail }}
          </p>
        </div>
      </div>
    </b-modal>

    <!-- New alert modal for validation messages -->
    <b-modal ref="new-alert-modal" :width="640" scroll="keep" title="Atención">
      <div class="container">
        <div class="content">
          <h1 class="is-5 spaced">
            {{ newAlert.title }}
          </h1>
          <div v-if="newAlert.detail.includes('\n')" class="alert-detail-multiline">
            <div v-for="(line, index) in newAlert.detail.split('\n')" :key="index" class="alert-line">
              {{ line }}
            </div>
          </div>
          <p v-else class="detail">
            {{ newAlert.detail }}
          </p>
        </div>
      </div>
      <template #modal-footer>
        <b-button variant="primary" @click="hideNewModal()">
          Entendido
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
// import firebase from 'firebase';

export default {
  name: "Form",
  props: {
    govId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      uploadValue: 0,
      imageLoader: false,
      center: {
        lat: 9.979304,
        lng: -84.0881,
      },
      provinces: [
        { id: 1, name: "San José" },
        { id: 2, name: "Alajuela" },
        { id: 3, name: "Cartago" },
        { id: 4, name: "Heredia" },
        { id: 5, name: "Guanacaste" },
        { id: 6, name: "Puntarenas" },
        { id: 7, name: "Limón" },
      ],
      rels: [
        'Hijo(a)',
        'Madre',
        'Padre',
        'Sobrino(a)',
        'Tío(a)',
        'Abuelo',
        'Abuela',
        'Pareja',
        'Otros',
      ],
      cantons: [],
      districts: [],
      options: [
        { name: "Sí", item: true },
        { name: "No", item: false },
      ],
      levels: [
        { name: "Bajo", item: false },
        { name: "Medio", item: false },
        { name: "Alto", item: false },
      ],
      requiredFieldsBeneficiary: {
        name: '',
        gov_id: '',
        relation: '',
        percentage: 0,
        phone: '',
        cell_phone: '',
        address_detail: '',
      },
      loadedLocation: true,
      loadedEmployee: false,
      numberPercentage: Array.from(Array(101).keys()),
      totalPercentage: 100,
      loadingEmployee: false,
      loadingCantons: false,
      loadingDistricts: false,
      loading: false,
      requiredFields: {
        code: "",
        name: "",
        phone: "",
        cell_phone: "",
        email: "",
        email_confirmation: "",
        province_id: null,
        canton_id: null,
        district_id: null,
        address_detail: "",
        image_url: "",
        marker: {},
      },
      form: {
        version: 3,
        employee_id: null,
        govId: "",
        code: "",
        name: "",
        phone: "",
        cell_phone: "",
        email: "",
        email_confirmation: "",
        province_id: null,
        canton_id: null,
        district_id: null,
        address_detail: "",
        emergency_contact: {
          name: "",
          phone: "",
          cell_phone: "",
          detail: "",
        },
        marker: {
          // lat: 9.979304,
          // lng: -84.0881,
          lng: -84.003,
          lat: 10.02708,
        },
        beneficiaries: [
          {
            name: '',
            gov_id: '',
            relation: '',
            percentage: 0,
            phone: '',
            cell_phone: '',
            address_detail: '',
          },
          {
            name: '',
            gov_id: '',
            relation: '',
            percentage: 0,
            phone: '',
            cell_phone: '',
            address_detail: '',
          },
        ],
        termsAccepted: false,
      },
      alert: {
        title: "",
        detail: "",
      },
      newAlert: {
        title: "",
        detail: "",
      },
    };
  },
  mounted() {
    if (this.govId) {
      this.form.govId = this.govId;
      this.doSearchEmployee();
    } else {
      this.setCurrentLocation();
    }
  },
  methods: {
    mark(event) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      this.form.marker = {
        lat: lat,
        lng: lng,
      };
    },
    resetForm() {
      this.loadedEmployee = false;
      this.form = {
        govId: "",
        code: "",
        name: "",
        phone: "",
        cell_phone: "",
        email: "",
        email_confirmation: "",
        emergency_contact: {
          name: "",
          phone: "",
          cell_phone: "",
          detail: "",
        },
        beneficiaries: [
          {
            name: '',
            gov_id: '',
            relation: '',
            percentage: 0,
            phone: '',
            cell_phone: '',
            address_detail: '',
          },
          {
            name: '',
            gov_id: '',
            relation: '',
            percentage: 0,
            phone: '',
            cell_phone: '',
            address_detail: '',
          },
        ],
        province_id: null,
        canton_id: null,
        district_id: null,
        address_detail: "",
        marker: {
          lng: -84.003,
          lat: 10.02708,
        },
        termsAccepted: false,
      };
      this.hideModal();
    },
    showModal() {
      this.$refs["alert-modal"].show();
    },
    showNewModal() {
      this.$refs["new-alert-modal"].show();
    },
    isValidEmail(email) {
      if (email != "") {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email) ? true : false;
      }
      return false;
    },
    isValidPhone(phone) {
      if (phone != "") {
        var re = /^\d{4}-\d{4}$/;
        var res = re.test(phone);
        return res ? true : false;
      }
      return false;
    },
    hideModal() {
      this.$refs["alert-modal"].hide();
    },
    hideNewModal() {
      this.$refs["new-alert-modal"].hide();
    },
    isValidForm() {
      for (let key in this.requiredFields) {
        const kval = this.form[key];
        if (!kval) {
          return false;
        }
      }
      if (!this.isValidEmail(this.form.email)) {
        return false;
      }
      if (this.form.email != this.form.email_confirmation) {
        return false;
      }
      // check beneficiaries
      if (this.form.associated) {
        this.form.beneficiaries.forEach((person) => {
          if (person.percentage !== 0) {
            for (let key in this.requiredFieldsBeneficiary) {
              const bval = person[key];
              if (!bval || bval === '') {
                return false;
              }
            }
          }
        });
      }
      return true;
    },
    validateForm() {
      const missingFields = [];

      // Check required fields
      for (let key in this.requiredFields) {
        const kval = this.form[key];
        if (!kval) {
          const fieldName = this.getFieldDisplayName(key);
          missingFields.push(fieldName);
        }
      }

      // Check email validation
      if (this.form.email && !this.isValidEmail(this.form.email)) {
        missingFields.push("Correo electrónico (formato inválido)");
      }

      // Check email confirmation
      if (this.form.email && this.form.email_confirmation && this.form.email != this.form.email_confirmation) {
        missingFields.push("Confirmación de correo electrónico (no coinciden)");
      }

      // Check beneficiaries if associated
      if (this.form.associated) {
        this.form.beneficiaries.forEach((person, index) => {
          if (person.percentage !== 0) {
            for (let key in this.requiredFieldsBeneficiary) {
              const bval = person[key];
              if (!bval || bval === '') {
                const fieldName = this.getBeneficiaryFieldDisplayName(key, index + 1);
                missingFields.push(fieldName);
              }
            }
          }
        });
      }

      if (missingFields.length > 0) {
        return {
          isValid: false,
          message: `Por favor complete los siguientes campos:\n\n${missingFields.join('\n')}`
        };
      }

      return {
        isValid: true,
        message: ""
      };
    },
    getFieldDisplayName(key) {
      const fieldNames = {
        code: "Número de gafete",
        name: "Nombre completo",
        phone: "Teléfono",
        cell_phone: "Celular",
        email: "Correo electrónico",
        email_confirmation: "Confirmación de correo electrónico",
        province_id: "Provincia",
        canton_id: "Cantón",
        district_id: "Distrito",
        address_detail: "Detalle de dirección",
        image_url: "Fotografía",
        marker: "Ubicación en el mapa"
      };
      return fieldNames[key] || key;
    },
    getBeneficiaryFieldDisplayName(key, beneficiaryNumber) {
      const fieldNames = {
        name: `Nombre del beneficiario ${beneficiaryNumber}`,
        gov_id: `Cédula del beneficiario ${beneficiaryNumber}`,
        relation: `Relación del beneficiario ${beneficiaryNumber}`,
        percentage: `Porcentaje del beneficiario ${beneficiaryNumber}`,
        phone: `Teléfono del beneficiario ${beneficiaryNumber}`,
        cell_phone: `Celular del beneficiario ${beneficiaryNumber}`,
        address_detail: `Dirección del beneficiario ${beneficiaryNumber}`
      };
      return fieldNames[key] || key;
    },
    equalsEmail() {
      if (!this.form.email) return false;
      if (!this.form.email_confirmation) return false;
      if (this.form.email != this.form.email_confirmation) {
        return false;
      }
      return true;
    },
    isValidValue(value) {
      if (!value) return false;
      if (value === "") return false;
      if (value === null) return false;
      return true;
    },
    isValidGovId() {
      const govId = this.form.govId;
      const amount = govId ? govId.length : 0;
      return amount > 8;
    },
    onChangePercentage(index) {
      if (this.form.beneficiaries.length === 2) {
        const indexModified = index === 0 ? 1 : 0;
        this.form.beneficiaries[indexModified].percentage = this.totalPercentage - this.form.beneficiaries[index].percentage;
      }
    },
    capitalizeName(name) {
      let nameParts = name.split(" ");
      var cleanName = "";
      for (var i = 0; i < nameParts.length; i++) {
        let nm = nameParts[i].toLowerCase();
        nm = nm.charAt(0).toUpperCase() + nm.slice(1);
        if (i != 0) {
          cleanName += " ";
        }
        cleanName += nm;
      }
      return cleanName;
    },
    loadEmployeeData(data) {
      this.form.first_name = data.name;
      this.form.last_name = data.lname;
      this.form.sur_name = data.sname;
      this.form.name = `${data.name} ${data.lname} ${data.sname}`;
      this.form.code = data.code;
      this.form.employee_id = data.id;
      this.form.associated = data.association;
      this.loadedEmployee = true;
    },
    doSearchEmployee() {
      this.loadingEmployee = true;
      axios
        .get(
          `${process.env.VUE_APP_SERVER_ENDPOINT}/dataUpdateEmployee?govId=${this.form.govId}&version=${this.form.version}`
        )
        .then((response) => {
          const data = response.data;
          (data) ? this.loadEmployeeData(data) : this.noEmployeeLoaded();
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => {
          this.loadingEmployee = false;
        });
    },
    loadCantons() {
      const province = this.form.province_id;
      if (province) {
        this.loadingCantons = true;
        axios
          .get(
            `${process.env.VUE_APP_SERVER_ENDPOINT}/cantons?provinceId=${province}`
          )
          .then((response) => {
            const results = response.data.results;
            if (results) {
              this.cantons = results;
              this.districts = [];
              this.form.canton_id = null;
              this.form.district_id = null;
            }
          })
          .catch(() => {
          })
          .finally(() => {
            this.loadingCantons = false;
          });
      }
    },
    loadAproxLocation() {
      if (this.form.province_id && this.form.canton_id && this.form.district_id) {
        const cantonName = this.getCantonName();
        const districtName = this.getDistrictName();
        const url = `${process.env.VUE_APP_GEOLOCATION_API}/${districtName},${cantonName},Costa Rica?json=1`;
        axios
          .get(url)
          .then((response) => {
            const data = response.data;
            if (data) {
              const lng = parseFloat(data.longt);
              const lat = parseFloat(data.latt);
              if (this.$refs.mapRef) {
                if (lat && lng) {
                  this.$refs.mapRef.$mapPromise.then((map) => {
                    map.panTo({ lat: lat, lng: lng });
                  });
                  this.center = {
                    lat: lat,
                    lng: lng,
                  };
                  this.form.marker = {
                    lat: lat,
                    lng: lng,
                  };
                }
              }
            }
          })
          .catch((error) => {
            // console.log(error);
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
            const status = error.response.status;
            if (status === 403) {
              alert("Por favor intente de nuevo");
            }
          })
          .finally(() => { });
      }
    },
    handleError(err) {
      this.form.name = "- -";
      this.form.code = "- -";
      this.alert = {
        title: "Ha ocurrido un error",
        detail: err.response.data[0],
      };
      this.loadedEmployee = false;
      this.showModal();
    },
    noEmployeeLoaded() {
      this.form.name = "- -";
      this.form.code = "- -";
      this.alert = {
        title: "Empleado no encontrado",
        detail: "No ha sido posible encontrar la cédula ingresada",
      };
      this.loadedEmployee = false;
      this.showModal();
    },
    loadDistricts() {
      const province = this.form.province_id;
      const canton = this.form.canton_id;
      if (province && canton) {
        this.loadingDistricts = true;
        axios
          .get(
            `${process.env.VUE_APP_SERVER_ENDPOINT}/districts?provinceId=${province}&cantonId=${canton}`
          )
          .then((response) => {
            let results = response.data.results;
            if (results) {
              this.districts = results;
              this.form.district_id = null;
            }
          })
          .catch(() => {
            this.form.name = "- -";
          })
          .finally(() => {
            this.loadingDistricts = false;
          });
      }
    },
    cleanData() {
      this.form = {
        ...this.form,
        version: 3,
        code: "",
        name: "",
        phone: "",
        cell_phone: "",
        email: "",
        email_confirmation: "",
        employee_id: null,
        province_id: null,
        canton_id: null,
        district_id: null,
        emergency_contact: {
          name: "",
          phone: "",
          cell_phone: "",
          detail: "",
        },
        beneficiaries: [
          {
            name: '',
            gov_id: '',
            relation: '',
            percentage: 0,
            phone: '',
            cell_phone: '',
            address_detail: '',
          },
          {
            name: '',
            gov_id: '',
            relation: '',
            percentage: 0,
            phone: '',
            cell_phone: '',
            address_detail: '',
          },
        ],
        address_detail: "",
        marker: {
          lng: -84.003,
          lat: 10.02708,
        },
        termsAccepted: false,
      };
      this.loadedEmployee = false;
    },
    setCurrentLocation() {
      navigator.geolocation.getCurrentPosition((position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        this.center = {
          lat: lat,
          lng: lng,
        };
        this.form.marker = {
          lat: lat,
          lng: lng,
        };
        // this.loadedLocation = true;
        if (this.$refs.mapRef) {
          this.$refs.mapRef.$mapPromise.then((map) => {
            map.panTo({ lat: lat, lng: lng });
          });
        }
      });
    },
    onFileChange(destination, loader) {
      const files = event.target.files;
      if (files.length > 0) {
        this[loader] = true;
        const uFile = files[0];
        if (uFile) {
          const formData = new FormData();
          formData.append("file", uFile);
          axios
            .post(
              `${process.env.VUE_APP_SERVER_ENDPOINT}/uploadImage`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((response) => {
              this.form[destination] = response.data.url;
            })
            .catch(() => {
              this.$bvModal.show("file-error-modal");
              this[loader] = false;
            })
            .finally(() => {
              this[loader] = false;
            });
        }
      }
    },
    doSubmit() {
      // Validate form before submission
      const validationResult = this.validateForm();
      if (!validationResult.isValid) {
        this.newAlert = {
          title: "Información incompleta",
          detail: validationResult.message,
        };
        this.showNewModal();
        return;
      }

      if (!this.form.termsAccepted) {
        this.newAlert = {
          title: "Atención",
          detail: "Debe aceptar los términos y condiciones para continuar",
        };
        this.showNewModal();
        return;
      }
      const { lat, lng } = this.form.marker;
      const final_form = {
        latitude: lat,
        longitude: lng,
        ...this.form,
      };
      this.loading = true;
      axios
        .post(
          `${process.env.VUE_APP_SERVER_ENDPOINT}/dataUpdate`,
          final_form,
        )
        .then(() => {
          this.resetForm();
          this.alert = {
            title: "Información guardada exitosamente",
            detail: "¡Gracias por actualizar sus datos!",
          };
          this.showModal();
        })
        .catch((err) => {
          const detail = err.response
            ? err.response.data
            : "Por favor intente de nuevo";
          this.newAlert = {
            title: "Ha ocurrido un error",
            detail: detail,
          };
          this.showNewModal();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-bottom: 20px;
  height: 100%;
}

.preview {
  max-height: 200px;
  object-fit: contain;
}

.disclaimer-box {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 15px;
}

.disclaimer-text {
  margin-bottom: 15px;
  line-height: 1.6;
  color: #495057;
}

.disclaimer-list {
  margin-bottom: 15px;
  padding-left: 20px;
}

.disclaimer-list li {
  margin-bottom: 8px;
  line-height: 1.5;
  color: #495057;
}

.alert-detail-multiline {
  margin-top: 15px;
  max-height: 300px;
  overflow-y: auto;
}

.alert-line {
  margin-bottom: 8px;
  line-height: 1.4;
  color: #495057;
  padding-left: 10px;
  border-left: 2px solid #dc3545;
}
</style>
